export default __webpack_public_path__ + "static/media/complementary--except-trucks--g1.e68b7c31.png";